/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ValidateKeyOrganization,
  ValidateKeyOrganization$inboundSchema,
} from "./validatekeyorganization.js";
import {
  ValidateKeyProject,
  ValidateKeyProject$inboundSchema,
} from "./validatekeyproject.js";

export type ValidateKeyResult = {
  organization: ValidateKeyOrganization;
  /**
   * The projects accessible with this key
   */
  projects: Array<ValidateKeyProject>;
  /**
   * List of permission scopes for this key
   */
  scopes: Array<string>;
};

/** @internal */
export const ValidateKeyResult$inboundSchema: z.ZodMiniType<
  ValidateKeyResult,
  unknown
> = z.object({
  organization: ValidateKeyOrganization$inboundSchema,
  projects: z.array(ValidateKeyProject$inboundSchema),
  scopes: z.array(z.string()),
});

export function validateKeyResultFromJSON(
  jsonString: string,
): SafeParseResult<ValidateKeyResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ValidateKeyResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ValidateKeyResult' from JSON`,
  );
}
